export default function AppDownload() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-background-950 to-foreground-800 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
              APP下载
            </h2>
            <p className="text-white/60 text-sm md:text-base leading-relaxed mb-6">
              下载吃瓜黑料爆料APP，随时随地掌握娱乐圈最新动态。
              推送通知让您不错过任何一条重磅瓜料，离线浏览也能畅快吃瓜。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-white text-foreground-950 font-medium rounded-lg text-sm whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 hover:bg-white/90 transition-colors"
              >
                <i className="ri-apple-fill text-lg"></i>
                iOS 版本
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-6 py-3 bg-accent-500 text-white font-medium rounded-lg text-sm whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 hover:bg-accent-600 transition-colors"
              >
                <i className="ri-android-fill text-lg"></i>
                Android 版本
              </a>
            </div>
          </div>
          <div className="w-40 md:w-48 h-64 md:h-72 relative flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20dark%20theme%20entertainment%20news%20app%20interface%20with%20vibrant%20red%20headlines%20and%20trending%20topic%20cards%2C%20sleek%20UI%20design%2C%20floating%20phone%20on%20transparent%20background%2C%20clean%20product%20shot&width=400&height=700&seq=app-mockup-01&orientation=portrait"
              alt="吃瓜黑料爆料APP截图"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}